<script lang="ts">
	import type { Store } from "$lib/def/landing";

	export let store: Store;
	export let selected = false;
</script>


<div class="object-elevation-3dp" id="storeContainer" class:selected-store={selected}>
	<div><!-- Column 1 -->
		{#if selected}
			<span class="icon-check-on-20"></span>
		{:else}
			<span class="hollow-circle-20"></span>
		{/if}
	</div>

	<div> <!-- Column 2 -->
		<div id="storeHeadline">
			<div class="label-xl bold" id="storeName">{store.name}</div>
			{#if !store.open}<span id="closedTag" class="label-caption medium">CLOSED</span>{/if}
		</div>
		<div class="label-m book">
			<span>{(Math.round(store.distance / 100) / 10).toFixed(1)} km</span> <!-- Distance comes in metres; want to display as km, one decimal place -->
			{#if store.open && store.operating_hours}<span id="tradingTimes">&middot; {store.operating_hours}</span>{/if}
		</div>
		{#if store.landing_notifications.store_notification}
			<div class="label-m medium">{store.landing_notifications.store_notification}</div>
		{:else if store.landing_notifications.warning_title}
			<div class="label-m medium" id="deliveryWarning">{store.landing_notifications.warning_title}</div>
		{/if}
		<div class="label-m book" id="liquorInfo">{store.liquor_availability}</div>
	</div>

	<div> <!-- Column 3-->
		<span class="icon-store-28"></span>
	</div>
</div>

<style lang="scss">
	@use "layout";
	@use "color";

	div#storeContainer {
		display: flex;
		align-items: center;
		gap: 12px;
		
		border-radius: layout.$border-radius;
		padding: 16px;
		margin-bottom: 8px;

		color: color.$on-background-high-importance;

		&.selected-store {
			border: 2px solid color.$on-background-high-importance;
		}

		> div:nth-child(1) { flex-grow: 0; }
		> div:nth-child(2) { flex-grow: 1; }
		> div:nth-child(3) { flex-grow: 0; }
	}

	div[class^="label-"] { margin: 0; }

	div#storeHeadline {
		display: flex;
		align-items: center;
		gap: 4px;

		> span#closedTag {
			border: 1px solid color.$separator;
			color: color.$on-background-medium-importance;
			padding: 3px 7px;
			border-radius: 24px;
			margin: 0;
		}
	}

	span#tradingTimes { color: color.$on-background-medium-importance; }

	div#deliveryWarning { color: color.$error; }

	div#liquorInfo { color: color.$on-background-medium-importance; }

	span.icon-check-on-20 { color: color.$primary-variant; }
	
	span.hollow-circle-20 {
		display: inline-block; // in order for the width + height props to take effect
		width: 20px;
		height: 20px;
		border-radius: 50%;
		border: 1.2px solid color.$on-background-low-importance;
	}
</style>